import SigliveServiceV2 from 'Service/sigliveServiceV2';

const getScheduleDetail = async ({ queries }) => {
  const { data } = await SigliveServiceV2({
    method: 'GET',
    url: `/schedule/details?${queries}`,
  });

  return data?.data;
};

export default getScheduleDetail;
